
export default function (Component) {
  Component.options.__source = "src/plugin/preview/components/preview.vue"
}
